import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
import { Binary } from '@angular/compiler';



export abstract class SellerData {
    //abstract fireRequest(data: Department, method: string): Observable<any>;
    abstract list(url: string): Observable<any>;
    abstract create(url: string, data: any): Observable<any[]>;
    abstract update(url: string, data: any): Observable<any>;
    abstract delete(url: string): Observable<any>;
    abstract getById(url: string): Observable<any>;
    // abstract listAuth(url: string): Observable<any>;

}
